// extracted by mini-css-extract-plugin
export var container = "_vh-0";
export var table = "_vh-2";
export var tableWrapper = "_vh-1";